import React, { useEffect, useMemo, useState } from 'react';
import { createStructuredSelector } from 'reselect';
import { useDispatch, useSelector } from 'react-redux';
import { DEFAULT_COVER_AMOUNTS, SF_COVER_CATEGORIES } from '@om/redux/actions/sizotsaFuneralCover/types';

import {
    OmFormInputFieldWrapper,
    OmCheckBox,
    OmSlider,
    OmLoader,
    OmSideDrawer,
    OmEfpAddCoverDrawer,
    OmButton,
    OmFormDropdownFieldWrapper,
    OmModalLoader,
} from '@om/component-library-react';

import { DEFAULT_VALIDATION_DELAY } from '../../../config';
import {
    getCoverType,
    getDisplayParentCoverOptions,
    getEditQuoteDetails,
    getHighestCoverAmount,
    getLivesCoveredCategoryOptions,
    getMainCoverAmount,
    getMonthlyPremiumQuote,
    getQuoteForm,
    getValueWithThousandSeperator,
} from '@om/redux/selectors/sizotsaFuneralCover/quote';
import {
    addToQuote,
    setQuoteDetailsStateValue,
    setQuoteDetailsValue,
    setQuoteDrawerValue,
    synchFormValue,
} from '@om/redux/actions/sizotsaFuneralCover/quote';
import { getQuoteRefernceData } from '@om/redux/selectors/sizotsaFuneralCover/referenceData';
import { FIELD_STATUS } from '@om/redux/reducers/status';
import { getQuoteRequest } from '@om/redux/actions/sizotsaFuneralCover/policyRequest';

const FormContent = () => {
    const {
        coverType,
        formFields,
        quoteRefrenceData,
        displayParentsandInLaws,
        displayCoverCategories,
        calculatedPremium,
        mainCoverAmount,
        highestCoverAmount,
        editQuoteDetails
    } = useSelector(
        createStructuredSelector({
            coverType: getCoverType,
            formFields: getQuoteForm,
            quoteRefrenceData: getQuoteRefernceData,
            displayParentsandInLaws: getDisplayParentCoverOptions,
            displayCoverCategories: getLivesCoveredCategoryOptions(),
            calculatedPremium: getMonthlyPremiumQuote,
            mainCoverAmount: getMainCoverAmount,
            highestCoverAmount: getHighestCoverAmount,
            editQuoteDetails:getEditQuoteDetails
        })
    );

    const { displayExtendedFamilyMembers, quoteDisplayCoverCategories } = quoteRefrenceData;
    const { dateOfBirth, age, relationship, coverAmount, monthlyPremium, selectedCoverCategory, title } = formFields;
    const displayCoverMembers = selectedCoverCategory?.value?.startsWith(SF_COVER_CATEGORIES.EXTENDED_FAMILY)
        ? displayExtendedFamilyMembers
        : displayParentsandInLaws;
    const actionHandler = (fieldType, value, displayValue = null) => {
        dispatch(setQuoteDetailsValue({ fieldType, value, displayValue }));
    };
const [debounceValue,setDebouncedValue,]=useState(false)

    const dispatch = useDispatch();
    useEffect(() => {
        calculatedPremium && actionHandler('monthlyPremium', calculatedPremium);
    }, [calculatedPremium]);

   
    useEffect(() => {
        !coverAmount.value &&
            coverType === SF_COVER_CATEGORIES.LIVES_COVERED_SIDE_DRAWER &&
            actionHandler('coverAmount', 5000);
    }, [coverType]);

//     useEffect(() => {
// age.value >=60 && actionHandler('coverAmount', 5000 );
//     }, [age.value]);
     const coverAmountOptionsval= [5000, 10000, 15000, 20000, 30000, 40000, 50000]
const coverOptionAboveFifty=[5000, 10000, 15000]
    const coverAmountOptions= useMemo(()=>{
return  (age.value >= 55 ? coverOptionAboveFifty: coverAmountOptionsval).filter((item)=>item <= mainCoverAmount) 
    },[age.value])

    useEffect(() => {        
        coverType === SF_COVER_CATEGORIES.LIVES_COVERED_SIDE_DRAWER && !coverAmountOptions.includes(+coverAmount.value) &&
        actionHandler('coverAmount', 5000);
}, [coverAmountOptions,age.value]);
// useEffect(() => {

//     const handler =dateOfBirth.status==='valid'&& setTimeout(() => {
//     //   setDebouncedValue(true);
//       setTimeout(()=>dispatch(getQuoteRequest()),3000)
//     }, 500);

//     return () => {
//       clearTimeout(handler);
//     };
//   }, [coverAmount.value]);
    return (
        <>
            <OmSideDrawer
                open={coverType === SF_COVER_CATEGORIES.LIVES_COVERED_SIDE_DRAWER}
                onOnSideDrawerClosed={() => {
                    dispatch(setQuoteDrawerValue({ fieldType: 'coverType', value: null }));
                    dispatch(
                        setQuoteDetailsStateValue({
                            fieldType: 'editQuoteDetails',
                            value: { id: null, category: null },
                        })
                    );
                    // dispatch(setSideDrawerClosed());
                }}
            >
                <div slot="side-drawer-content">
                    <OmEfpAddCoverDrawer>
                        <div className="progressive-disclosure-form-wrapper">
                            <h6 className="no-top-margin medium">Who would  like to cover?</h6>
                            {/* <OmModalLoader
                    slot="loading-modal"
                    loaderText="Verifying your details"
                    verticalAlignNiddle={true}
                    open={debounceValue}
                /> */}
                            <OmFormDropdownFieldWrapper
                                align="left"
                                placeholder="Select a cover category"
                                placeholderAsLabel="false"
                                formId="addLivesCovered"
                                size="full"
                                name="coverCategory"
                                required
                                disabled={!!title.value}
                                useNativeMobileDropdown
                                value={selectedCoverCategory && selectedCoverCategory?.value}
                                state={selectedCoverCategory && selectedCoverCategory.status}
                                errorMessage={selectedCoverCategory && selectedCoverCategory.error}
                                options={JSON.stringify(
                                    displayCoverCategories &&
                                        displayCoverCategories.map((category) => ({
                                            value: category.code,
                                            label: category.description,
                                            disabled: category.disabled,
                                        }))
                                )}
                                onOnSelect={(event) => {
                                    actionHandler(
                                        'selectedCoverCategory',
                                        event.detail.value.startsWith('My Extended')
                                            ? SF_COVER_CATEGORIES.EXTENDED_FAMILY
                                            : event.detail.value === 'Child' ? SF_COVER_CATEGORIES.ME_AND_MY_DIRECT_FAMILY : SF_COVER_CATEGORIES.PARENTS_AND_IN_LAWS
                                    );
                                    relationship.value && actionHandler('relationship', null);
                                    dateOfBirth.value && actionHandler('dateOfBirth', dateOfBirth.value);
                                }}
                            />
                            <OmFormDropdownFieldWrapper
                                align="left"
                                label=" "
                                placeholder="What's your relationship?*"
                                placeholderAsLabel="false"
                                formId="addInLaws"
                                size="full"
                                name={`Relationship${relationship.value ?? ''}`}
                                useNativeMobileDropdown
                                required
                                disabled={!!title.value}
                                key={relationship.value}
                                value={relationship?.value}
                                state={relationship?.status}
                                errorMessage={relationship?.error}
                                options={JSON.stringify(
                                    displayCoverMembers &&
                                        displayCoverMembers.map((coverCategory) => ({
                                            value: coverCategory.code,
                                            label: coverCategory.description,
                                            disabled: coverCategory.disabled,
                                        }))
                                )}
                                onOnSelect={(event) => actionHandler('relationship', event.detail.value)}
                            />

                            <OmFormInputFieldWrapper
                                isSensitive
                                required
                                labelAlwaysShow
                                id="ageField"
                                mask="date"
                                size="full"
                                formId="addLivesCovered"
                                name="Age"
                                align="left"
                                label="Date of birth*"
                                placeholder={'DD/MM/YYYY'}
                                hintText={'Format : dd/mm/yyyy'}
                                validationDelay={DEFAULT_VALIDATION_DELAY}
                                value={dateOfBirth?.value}
                                state={age && age?.status}
                                errorMessage={dateOfBirth?.error || age?.error}
                                onPersist={(event) => actionHandler('dateOfBirth', event.detail)}
                            />
                            {dateOfBirth?.status === FIELD_STATUS.VALID && (
                                <>
                                 <h6 className="no-bottom-margin">Select cover amount:</h6>
                                 <OmSlider
                                        key="livescovered"
                                        id="lmskskm"
                                        stepString={JSON.stringify(coverAmountOptions
                                        )}
                                        minLabel={`E${coverAmountOptions[0]}`}
                                        maxLabel={`E${coverAmountOptions.at(-1)}`}
                                        value={coverAmount?.value ?? 5000}
                                        valuePrefix={'E'}
                                        onSliderChange={(event) => actionHandler('coverAmount', event.detail)}
                                    />

<div
                                        className="cover-label-wrapper medium-margin-top"
                                        style={{ flexWrap: 'wrap' }}
                                    >
                                        <span className="cover-label" style={{  }}>
                                            <h5 className="no-bottom-margin no-top-margin medium">
                                                E {getValueWithThousandSeperator(coverAmount?.value)}
                                            </h5>
                                            <p className="small medium no-top-margin">Cover Amount</p>
                                        </span>

                                        <span className="cover-label" style={{textAlign:'right'}}>
                                            <h5 className="no-bottom-margin no-top-margin medium">
                                                E {monthlyPremium?.value?.toFixed(2) ?? 0} PM / E {getValueWithThousandSeperator((+monthlyPremium?.value * 12)?.toFixed(2))} PA
                                            </h5>
                                            <p className="small medium no-top-margin base-margin-bottom">
                                                Total Premium
                                            </p>
                                          
                                        </span>
                                    </div>
                                </>
                            )}
                            <div slot="modal-content"></div>

                            <div className="action-buttons">
                              {editQuoteDetails.id ?<OmButton
                                        type="text"
                                        size="small"
                                        text="CANCEL"
                                        onClick={() => {
                                            dispatch(setQuoteDrawerValue({ fieldType: 'coverType', value: null }));
                                            dispatch(
                                                setQuoteDetailsStateValue({
                                                    fieldType: 'editQuoteDetails',
                                                    value: { id: null, category: null },
                                                })
                                            );
                                        }}
                                    />: <OmButton
                                    type="text"
                                    size="small"
                                    text="CLEAR ALL"
                                     onClick={() => { dispatch(
                                        setQuoteDrawerValue({
                                            fieldType: 'coverType',
                                            value: SF_COVER_CATEGORIES.LIVES_COVERED_SIDE_DRAWER,
                                        })
                                    )
                                    actionHandler('coverAmount', 5000);}}
                                />}
                                <OmButton
                                    type="primary"
                                    size="small"
                                    text={'ADD TO QUOTE'}
                                    onClick={() => {
                                        coverAmount?.value > highestCoverAmount &&
                                            dispatch(
                                                setQuoteDetailsStateValue({
                                                    fieldType: 'highestCoverAmount',
                                                    value: coverAmount?.value,
                                                })
                                            );
                                        dispatch(
                                            addToQuote({
                                                coverType:
                                                    selectedCoverCategory?.value ===
                                                    SF_COVER_CATEGORIES.EXTENDED_FAMILY
                                                        ? SF_COVER_CATEGORIES.EXTENDED_FAMILY
                                                        : selectedCoverCategory?.value === 'Child'
                                                        ? SF_COVER_CATEGORIES.ME_AND_MY_DIRECT_FAMILY
                                                        : SF_COVER_CATEGORIES.PARENTS_AND_IN_LAWS,
                                                relation: relationship ? relationship?.value : 'child',
                                            })
                                        );
                                    }}
                                />
                            </div>
                        </div>
                    </OmEfpAddCoverDrawer>
                </div>
            </OmSideDrawer>
        </>
    );
};

const loadingText = (directFamilyDrawerOpen) => {
    return (
        <>
            <OmSideDrawer
                // open={directFamilyDrawerOpen}
                open={false}
                onOnSideDrawerClosed={() => {
                    dispatch(cancelEditCover());
                    dispatch(setSideDrawerClosed());
                }}
            >
                <div slot="side-drawer-content">
                    <OmEfpAddCoverDrawer>
                        <div className="progressive-disclosure-form-wrapper">
                            <OmLoader loaderText={'Loading...'} isLoading={true} />

                            <div className="action-buttons">
                                <OmButton type="text" size="small" text="CLEAR ALL" onClick={() => clearAll()} />
                                <OmButton
                                    type="primary"
                                    size="small"
                                    text={'ADD TO QUOTE'}
                                    // onClick={() => addToQuote()}
                                />
                            </div>
                        </div>
                    </OmEfpAddCoverDrawer>
                </div>
            </OmSideDrawer>
        </>
    );
};

const LivesCoveredSideDrawer = () => {
    // if (applicationReferenceDataValid && quoteReferenceDataValid) {
    return <FormContent />;
    // }

    // return (
    //     <div>
    //         {loadingText(directFamilyDrawerOpen)}
    //     </div>
    // );
};

export default LivesCoveredSideDrawer;
